export const PERSPECTIVE_DEGREES = (Math.atan(64.5 / 126) * 180) / Math.PI; // (width and height from figma)
